var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-null no-select"},[(_vm.img)?_c('img',{staticClass:"img",attrs:{"src":require("img/error/empty.png")}}):_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#iconmeiyoushuju"}})]),_c('p',[_vm._t("default",function(){return [_c('span',[_vm._v(_vm._s(_vm.tips))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }